import { Avatar, Box, Button, Popover, Typography } from '@mui/material';
import * as React from 'react';
import { useAuthorization } from '../Contexts/Hooks/useAuth';
import { useNavigate } from 'react-router';
import { LogoutOutlined, PeopleOutline, RemoveRedEye, Storage } from '@mui/icons-material';
import ChangePasswordDialog from '../Users/ChangePasswordDialog';
import BudgetItemsDetailDialog from '../Projects/Components/BudgetItemsDetailDialog';
import { BudgetItemTemplateDto } from '../Api/ApiServer';

export interface IUserTopMenuProps {
}

export default function UserTopMenu(props: IUserTopMenuProps) {
    // const [popoverOpen, setPopoverOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
    const { logout, isAdmin, isSuperAdmin, userData } = useAuthorization();
    const navigate = useNavigate();
    const [changingPassword, setChangingPassword] = React.useState(false);
    const [budgetItemsOpen, setBudgetItemsOpen] = React.useState(false);
    return (
        <Box display='flex'
            justifyContent='space-between'
            alignItems='center'
            overflow={'hidden'}
            // width='100%'
            bgcolor={'white'}
            height={'56px'}
            px={4}
            zIndex={2}
            boxShadow={3}
            width='100vw'
            position='fixed'>
            <ChangePasswordDialog onClose={() => setChangingPassword(false)} open={changingPassword} />
            <Box 
            onClick={() => {
                navigate('/logged/projects');
            }}>
                <img src='/ryc_logo.png' alt='logo' style={{ height: '40px' }} />
            </Box>
            <Box>
                <Avatar
                sx={{ bgcolor: 'primary.main', cursor: 'pointer' }}
                onClick={(e) => setAnchorEl(e.currentTarget)}>{userData?.initials}</Avatar>
                <Popover
                    id={'simple-popover'}
                    open={anchorEl !== null}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Box display='flex' alignItems='start' justifyContent={'start'}  flexDirection='column'>
                        {(isAdmin || isSuperAdmin) && <Button fullWidth color='info' sx={{ py: 1, px: 3 }} startIcon={<PeopleOutline />} onClick={() => { navigate('/logged/admin'); }}>ADMIN</Button>}
                        <Button fullWidth startIcon={<Storage />} sx={{ py: 1, px: 3 }} color='info' onClick={() => { setAnchorEl(null); setBudgetItemsOpen(true)}}>Databáze položek</Button>
                        <Button fullWidth startIcon={<RemoveRedEye />} sx={{ py: 1, px: 3 }} color='info' onClick={() => { setChangingPassword(true)}}>Změna hesla</Button>
                        <Button fullWidth startIcon={<LogoutOutlined />} sx={{ py: 1, px: 3 }} color='info' onClick={() => { logout(); navigate('/'); }}>Odhlásit</Button>
                    </Box>
                </Popover>
                <BudgetItemsDetailDialog onClose={() => setBudgetItemsOpen(false)} open={budgetItemsOpen} onSelect={() => {} } />
            </Box>
        </Box>
    );
}
